import { render } from "./TextMedia.vue?vue&type=template&id=271722bd&scoped=true"
import script from "./TextMedia.vue?vue&type=script&lang=js"
export * from "./TextMedia.vue?vue&type=script&lang=js"

import "./TextMedia.vue?vue&type=style&index=0&id=271722bd&scoped=true&lang=scss"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271722bd"]])

export default __exports__